import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import starTexture from './textures/2k_stars_milky_way.jpg';
import sunTexture from './textures/2k_sun.jpg';
import mercuryTexture from './textures/2k_mercury.jpg';
import venusTexture from './textures/2k_venus_atmosphere.jpg';
import marsTexture from './textures/2k_mars.jpg';
import earthTexture from './textures/RS3_EarthC.jpg';
import jupiterTexture from './textures/2k_jupiter.jpg';
import saturnTexture from './textures/2k_saturn.jpg';
import saturnRingTexture from './textures/2k_saturn_ring_alpha.png';
import uranusTexture from './textures/2k_uranus.jpg';
import neptuneTexture from './textures/2k_neptune.jpg';
import plutoTexture from './textures/th.jpeg';
import moonTexture from './textures/2k_moon.jpg';

const renderer = new THREE.WebGLRenderer();

renderer.setSize(window.innerWidth, window.innerHeight);

document.body.appendChild(renderer.domElement);

const scene = new THREE.Scene();

const camera = new THREE.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.1, 1000);

const orbit = new OrbitControls(camera, renderer.domElement);

camera.position.set(-90, 140, 140);
orbit.update();

const ambientLight = new THREE.AmbientLight(0x333333);
scene.add(ambientLight);

const cubeTextureLoad = new THREE.CubeTextureLoader();
scene.background = cubeTextureLoad.load([starTexture]);

const textureLoader = new THREE.TextureLoader();

//*SUN
const sunGeo = new THREE.SphereGeometry(20, 30, 30);
const sunMat = new THREE.MeshBasicMaterial({
    map: textureLoader.load(sunTexture)
});

const sun = new THREE.Mesh(sunGeo, sunMat);
scene.add(sun);

//planets
function createplanets(size, texture, position, positionY, ring) {
    const geo = new THREE.SphereGeometry(size, 30, 30);
    const mat = new THREE.MeshStandardMaterial({
        map: textureLoader.load(texture)
    });

    const mesh = new THREE.Mesh(geo, mat);
    //scene.add(sun);
    const obj = new THREE.Object3D();
    obj.add(mesh);
    if(ring) {
        const ringGeo = new THREE.RingGeometry(ring.innerRadius, ring.outerRadius, 34);
        const ringMat = new THREE.MeshBasicMaterial({
            map: textureLoader.load(ring.texture),
            side: THREE.DoubleSide
        });
        const ringMesh = new THREE.Mesh(ringGeo, ringMat);
        //scene.add(sun);
        obj.add(ringMesh);
        ringMesh.position.x = position;
        ringMesh.rotation.x = -0.5 *Math.PI;
    }
    scene.add(obj);
    mesh.position.x = position;
    mesh.position.y = positionY;
    return {mesh, obj}
}
//near earth object
//near earth objects
// Stars
function createStar() {
    const geometry = new THREE.SphereGeometry(0.7, 16, 16);
    const material = new THREE.MeshBasicMaterial({ color: 0xffff });
    const star = new THREE.Mesh(geometry, material);
    
    // Random position for stars
    star.position.set(
        (Math.random() - 0.6) * 320,
        (Math.random() - 0.4) * 10,
        (Math.random() - 0.5) * 350
    );

    scene.add(star);
}

// Create multiple stars
for (let i = 0; i < 100; i++) {
    createStar();
}


//* MERCURY
const mercury = createplanets(3.2, mercuryTexture, 28, 0);
const mercuryObj = new THREE.Object3D();
mercuryObj.add(mercury);
scene.add(mercuryObj);

//mercury orbitpath
const mercuryRingGeo = new THREE.RingGeometry(28, 29, 65);
const mercuryRingMat = new THREE.MeshBasicMaterial({ color: 0xffff00, side: THREE.DoubleSide });
const mercuryRing = new THREE.Mesh(mercuryRingGeo, mercuryRingMat);

mercuryObj.add(mercuryRing);
mercuryRing.rotateX(190.1);
mercuryRing.position.x = 0;

//venus
const venus = createplanets(5.8, venusTexture, 44, 0);
const venusObj = new THREE.Object3D();
venusObj.add(venus);
scene.add(venusObj);

//venus orbitpath
const venusRingGeo = new THREE.RingGeometry(45 , 46, 65);
const venusRingMat = new THREE.MeshBasicMaterial({ color: 0x0f5f5f, side: THREE.DoubleSide });
const venusRing = new THREE.Mesh(venusRingGeo, venusRingMat);

venusObj.add(venusRing);
venusRing.rotateX(190.1);
venusRing.position.x = 0;


//earth
const earth = createplanets(6, earthTexture, 62, 0);
const earthObj = new THREE.Object3D();
earthObj.add(earth);
scene.add(earthObj);

//earth orbitpath
const earthRingGeo = new THREE.RingGeometry(63 , 64, 65);
const earthRingMat = new THREE.MeshBasicMaterial({ color: 0x00ffff, side: THREE.DoubleSide });
const earthRing = new THREE.Mesh(earthRingGeo, earthRingMat);

earthObj.add(earthRing);
earthRing.rotateX(190.1);
earthRing.position.x = 0;

//earth-moon
const moon = createplanets(1, moonTexture, 69, 5);

//mars
const mars = createplanets(4, marsTexture, 78, 0);
const marsObj = new THREE.Object3D();
marsObj.add(mars);
scene.add(marsObj);

//mars orbitpath
const marsRingGeo = new THREE.RingGeometry(76 , 77, 65);
const marsRingMat = new THREE.MeshBasicMaterial({ color: 0xff9C38, side: THREE.DoubleSide });
const marsRing = new THREE.Mesh(marsRingGeo, marsRingMat);

marsObj.add(marsRing);
marsRing.rotateX(190.1);
marsRing.position.x = 0;

//jupiter
const jupiter = createplanets(12, jupiterTexture, 100, 0);
const jupiterObj = new THREE.Object3D();
jupiterObj.add(jupiter);
scene.add(jupiterObj);

//jupiter orbitpath
const jupiterRingGeo = new THREE.RingGeometry(98 , 99, 75);
const jupiterRingMat = new THREE.MeshBasicMaterial({ color: 0x00DB58, side: THREE.DoubleSide });
const jupiterRing = new THREE.Mesh(jupiterRingGeo, jupiterRingMat);

jupiterObj.add(jupiterRing);
jupiterRing.rotateX(190.1);


//SATURN
const saturn = createplanets(10, saturnTexture, 138, 0, {
    innerRadius: 12,
    outerRadius: 24,
    texture: saturnRingTexture
});
const saturnObj = new THREE.Object3D();
saturnObj.add(mars);
scene.add(saturnObj);

//saturn orbitpath
const saturnRingGeo = new THREE.RingGeometry(134 , 135, 75);
const saturnRingMat = new THREE.MeshBasicMaterial({ color: 0xCBA8FF, side: THREE.DoubleSide });
const saturnRing = new THREE.Mesh(saturnRingGeo, saturnRingMat);

saturnObj.add(saturnRing);
saturnRing.rotateX(190.1);
saturnRing.position.x = 0;

//uranus
const uranus = createplanets(7, uranusTexture, 176, 0);
const uranusObj = new THREE.Object3D();
uranusObj.add(uranus);
scene.add(uranusObj);

//uranus orbitpath
const uranusRingGeo = new THREE.RingGeometry(174 , 175, 75);
const uranusRingMat = new THREE.MeshBasicMaterial({ color: 0xff3d3d, side: THREE.DoubleSide });
const uranusRing = new THREE.Mesh(uranusRingGeo, uranusRingMat);

uranusObj.add(uranusRing);
uranusRing.rotateX(190.1);
marsRing.position.x = 0;

//neptune
const neptune = createplanets(7, neptuneTexture, 200, 0);
const neptuneObj = new THREE.Object3D();
neptuneObj.add(mars);
scene.add(neptuneObj);

//neptune orbitpath
const neptuneRingGeo = new THREE.RingGeometry(198 , 199, 75);
const neptuneRingMat = new THREE.MeshBasicMaterial({ color: 0x005C5C, side: THREE.DoubleSide });
const neptuneRing = new THREE.Mesh(neptuneRingGeo, neptuneRingMat);

neptuneObj.add(neptuneRing);
neptuneRing.rotateX(190.1);
neptuneRing.position.x = 0;

//pluto
const pluto = createplanets(2.8, plutoTexture, 216, 0);
const plutoObj = new THREE.Object3D();
plutoObj.add(pluto);
scene.add(plutoObj);

//pluto orbitpath
const plutoRingGeo = new THREE.RingGeometry(213, 215, 75);
const plutoRingMat = new THREE.MeshBasicMaterial({ color: 0xffffff, side: THREE.DoubleSide });
const plutoRing = new THREE.Mesh(plutoRingGeo, plutoRingMat);
plutoObj.add(plutoRing);
plutoRing.rotateX(190.1);



//pointerlight
const pointLight = new THREE.PointLight(0xffffff, 3, 300, 0.1);
scene.add(pointLight);

function animate() {
    //self-rotation
    sun.rotateY(0.004);
    mercury.mesh.rotateY(0.004);
    venus.mesh.rotateY(0.004);
    earth.mesh.rotateY(0.02);
    mars.mesh.rotateY(0.018);
    jupiter.mesh.rotateY(0.04)
    neptune.mesh.rotateY(0.032);
    uranus.mesh.rotateY(0.03);
    pluto.mesh.rotateY(0.008);
    saturn.mesh.rotateY(0.038);

    //around-sun-rotation
    mercury.obj.rotateY(0.04);
    venus.obj.rotateY(0.015);
    earth.obj.rotateY(0.01);
    moon.obj.rotateY(0.01)
    mars.obj.rotateY(0.008);
    jupiter.obj.rotateY(0.002);
    uranus.obj.rotateY(0.0004);
    neptune.obj.rotateY(0.0001);
    pluto.obj.rotateY(0.00007); 
    saturn.obj.rotateY(0.0009);
    renderer.render(scene, camera);
}

renderer.setAnimationLoop(animate);

window.addEventListener('resize', function() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
});